import { AspectRatioBox, Box, Button, Flex, IconButton, Input, Text, useClipboard, useColorMode } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import QRCode from 'qrcode.react';
import React, { useRef } from 'react';
import { MdContentCopy } from 'react-icons/md';

import { useStores } from '../hooks/useStores';

const useStoreData = () => {
    const { store } = useStores();
    return useObserver(() => ({
        completeShareLink: `${window.location.origin}${store.config.shareLink}`,
        shareLink: store.config.shareLink,
        currentTrackColors: store.config.currentTrackColors,
    }));
};

const SharePanel = () => {
    const { shareLink, currentTrackColors, completeShareLink } = useStoreData();
    const { colorMode } = useColorMode();
    const color = { light: 'gray.900', dark: 'gray.100' };
    const { onCopy, hasCopied } = useClipboard(completeShareLink);

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            direction="column"
            maxH="100vh"
            color={color[colorMode]}
            w="100%"
            overflow="hidden"
        >
            <Text alignSelf="flex-start" p=".5rem" fontSize={['20px', '25px', '25px']}>
                Share playlist link
            </Text>
            <Flex
                flex={1}
                justifyContent="center"
                direction="column"
                maxW={['400px', '600px', '600px']}
                w="100%"
                alignItems="center"
            >
                <Box overflow="hidden" borderRadius="10px" w={['200px', '300px', '400px']}>
                    <QRCode
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        includeMargin
                        value={completeShareLink}
                        bgColor={currentTrackColors[2]}
                        fgColor={'white'}
                    />
                </Box>
                <Flex justifyContent="space-between" w="100%" maxW="100%" p="1rem">
                    <Input isReadOnly value={shareLink} flex={1} mr="2" />
                    <Button color={currentTrackColors[2]} onClick={onCopy}>
                        {hasCopied ? 'Copied' : 'Copy'}
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default SharePanel;
